export const wait = (delayInMS: number) => {
  return new Promise(resolve => setTimeout(() => resolve(true), delayInMS));
};
